import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";

export default function SearchInput({ value, onChange, placeholder = "Rechercher…", testid = "search-input" }) {
  return (
    <div className="relative w-full sm:w-64">
      <Search className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none" />
      <Input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="pl-9 h-9"
        data-testid={testid}
      />
    </div>
  );
}
